var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 3.5C3.64543 3.5 2.75 4.39543 2.75 5.5V14V18.5C2.75 20.1569 4.09315 21.5 5.75 21.5H19.75C21.4069 21.5 22.75 20.1569 22.75 18.5V9.5C22.75 7.84315 21.4069 6.5 19.75 6.5H14.25H13.9861L13.0389 4.60557C12.7001 3.928 12.0075 3.5 11.25 3.5H4.75ZM11.75 6.5L11.25 5.5H6.75H4.75V6.5H11.75ZM4.75 8.5V14V18.5C4.75 19.0523 5.19772 19.5 5.75 19.5H19.75C20.3023 19.5 20.75 19.0523 20.75 18.5V9.5C20.75 8.94771 20.3023 8.5 19.75 8.5H14.25H13.368H4.75ZM8.75 14C8.75 13.4477 9.19772 13 9.75 13H11.75V11C11.75 10.4477 12.1977 10 12.75 10C13.3023 10 13.75 10.4477 13.75 11V13H15.75C16.3023 13 16.75 13.4477 16.75 14C16.75 14.5523 16.3023 15 15.75 15H13.75V17C13.75 17.5523 13.3023 18 12.75 18C12.1977 18 11.75 17.5523 11.75 17V15H9.75C9.19772 15 8.75 14.5523 8.75 14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPlus);
export default __webpack_public_path__ + "static/media/folder_plus.9b20a308c55b311e2beabca010bf7ca2.svg";
export { ForwardRef as ReactComponent };